import { DemandeAffiliationStatutConsultantEnum } from '@graphql/generated';
import { DemandeAffiliationStatutConsultant } from '@lib/models/demande-affiliation/types/demande-statut.type';

export class StatutConsultantMapper {
  public static toGraphQl(
    input: DemandeAffiliationStatutConsultant | null
  ): DemandeAffiliationStatutConsultantEnum | undefined {
    const mapping: Record<
      DemandeAffiliationStatutConsultant,
      DemandeAffiliationStatutConsultantEnum
    > = {
      affilie: DemandeAffiliationStatutConsultantEnum.Affilie,
      annule: DemandeAffiliationStatutConsultantEnum.Annule,
      brouillon: DemandeAffiliationStatutConsultantEnum.Brouillon,
      en_cours_prodemial: DemandeAffiliationStatutConsultantEnum.EnCoursProdemial,
      en_signature: DemandeAffiliationStatutConsultantEnum.EnSignature,
      expire: DemandeAffiliationStatutConsultantEnum.Expire,
      nc_a_traiter: DemandeAffiliationStatutConsultantEnum.NcATraiter,
      refuse: DemandeAffiliationStatutConsultantEnum.Refuse,
      soumis_prodemial: DemandeAffiliationStatutConsultantEnum.SoumisProdemial,
    };
    return input ? mapping[input] : undefined;
  }

  public static fromGraphQl(
    input: DemandeAffiliationStatutConsultantEnum | null
  ): DemandeAffiliationStatutConsultant | undefined {
    const mapping: Record<
      DemandeAffiliationStatutConsultantEnum,
      DemandeAffiliationStatutConsultant
    > = {
      AFFILIE: 'affilie',
      ANNULE: 'annule',
      BROUILLON: 'brouillon',
      EN_COURS_PRODEMIAL: 'en_cours_prodemial',
      EN_SIGNATURE: 'en_signature',
      EXPIRE: 'expire',
      NC_A_TRAITER: 'nc_a_traiter',
      REFUSE: 'refuse',
      SOUMIS_PRODEMIAL: 'soumis_prodemial',
    };
    return input ? mapping[input] : undefined;
  }
}
